// Calm notes about the email behind a card: who really sent it, and whether the email holds more
// than the reader can see. Plain words, no alarm: the owner decides what to make of them.
import type { CardMailCheck } from "@shared/api";

export const SENDER_UNVERIFIED = "Gmail couldn't verify this sender.";
export const PLAIN_TEXT_SAYS_MORE =
  "This email's plain-text version says more than the version you see. Claude read only what you see.";

export function mailCheckNotes(check: CardMailCheck | null | undefined): string[] {
  if (!check) return [];
  const notes: string[] = [];
  if (check.senderUnverified) notes.push(SENDER_UNVERIFIED);
  if (check.plainTextSaysMore) notes.push(PLAIN_TEXT_SAYS_MORE);
  return notes;
}
